// مجرد استديو — Design tokens & data

export const C = {
    bg:      '#EDEAFB',
    card:    '#FAF8FF',
    ink:     '#0E0B2E',
    ink70:   'rgba(14, 11, 46, 0.72)',
    ink50:   'rgba(14, 11, 46, 0.52)',
    ink20:   'rgba(14, 11, 46, 0.14)',
    line:    'rgba(14, 11, 46, 0.10)',
    i500:    '#5B4FE5',
    i400:    '#7E67D6',
    i300:    '#A291E3',
    i200:    '#C9BEEF',
    i100:    '#E4DEF7',
    amber:   '#F2C94C',
    coral:   '#FF8A65',
    mint:    '#6FE3C1',
};

export interface Division {
    num: string;
    ar: string;
    en: string;
    color: string;
    desc: string;
    tools: string[];
}

export const DIVISIONS: Division[] = [
    {
        num: '01', ar: 'تحليل السوق والبيانات', en: 'Market Intelligence',
        color: '#8A7CFF',
        desc: 'قبل أي خطوة، نفهم السوق. نرصد المنافسين، نحلل سلوك جمهورك، ونكشف الفرص المخفية — بالبيانات لا بالتخمين.',
        tools: ['تحليل المنافسين', 'Audience Insights', 'بحث SEO', 'تقارير سوقية'],
    },
    {
        num: '02', ar: 'بناء الاستراتيجية', en: 'Strategy Building',
        color: '#4A3FC9',
        desc: 'بناءً على البيانات، نرسم خارطة طريق تسويقية كاملة — أهداف واضحة، قنوات مختارة، رسائل مؤثرة، وميزانية مُحكمة.',
        tools: ['خطة محتوى شهرية', 'Brand Positioning', 'خطة إعلانية', 'OKRs تسويقية'],
    },
    {
        num: '03', ar: 'إنتاج المحتوى والإبداع', en: 'Content & Creative',
        color: '#FF8A65',
        desc: '12 وكيل ذكاء صناعي في استديو واحد — مقالات، تصاميم احترافية، CGI، سكربتات فيديو، ومنشورات سوشال — بجودة لا تنتظر.',
        tools: ['تصميم جرافيك', 'CGI · 3D', 'كتابة إعلانات', 'سكربت ريلز', 'مطبوعات'],
    },
    {
        num: '04', ar: 'إطلاق وإدارة الحملات', en: 'Campaign Management',
        color: '#F2C94C',
        desc: 'نطلق حملاتك على كل المنصات، نراقب الأداء لحظة بلحظة، ونحسّن الإنفاق تلقائياً لأقصى عائد ممكن.',
        tools: ['Meta Ads', 'Google Ads', 'TikTok Ads', 'تقارير أسبوعية'],
    },
    {
        num: '05', ar: 'إدارة العملاء — CRM', en: 'Customer Relationship',
        color: '#6FE3C1',
        desc: 'الحملة لا تنتهي عند البيع. نبني علاقة مستمرة مع عملائك — متابعة، رعاية، وإعادة استهداف — بدون جهد يدوي.',
        tools: ['Email Automation', 'Lead Nurturing', 'Retention', 'تقسيم الجمهور'],
    },
    {
        num: '06', ar: 'النشر الذكي على السوشال', en: 'Smart Publishing',
        color: '#F472B6',
        desc: 'ننشر على حساباتك مباشرة — في الوقت المثالي، بالتنسيق الصحيح لكل منصة، بجدول محكم لا يتعطّل.',
        tools: ['Instagram', 'TikTok', 'X · تويتر', 'LinkedIn', 'Snapchat', 'YouTube'],
    },
    {
        num: '07', ar: 'التكاملات والربط', en: 'Integrations & APIs',
        color: '#34D399',
        desc: 'نتصل مباشرة بمنصاتك الحالية عبر API — بيانات حقيقية، قرارات فورية، بدون نسخ ولصق يدوي.',
        tools: ['Google Analytics', 'Meta Business', 'TikTok API', 'Shopify', 'HubSpot', 'Semrush', 'Zapier', 'WhatsApp API'],
    },
    {
        num: '08', ar: 'التقارير والرؤى', en: 'Reporting & Insights',
        color: '#60A5FA',
        desc: 'تقارير أسبوعية وشهرية تُترجم الأرقام إلى قرارات — لا بيانات خام، بل رؤى جاهزة للتنفيذ.',
        tools: ['تقارير أداء الحملات', 'تحليل ROI', 'نمو الجمهور', 'مقارنة المنافسين', 'تقرير المحتوى'],
    },
];

export const STATS = [
    { n: '12+', l: 'وكيل ذكاء صناعي متخصص', en: 'AI Agents' },
    { n: '5x',  l: 'متوسط نمو العملاء خلال 90 يوم', en: 'Avg. Growth' },
    { n: '85%', l: 'توفير في تكلفة التسويق', en: 'Cost Savings' },
    { n: '24/7', l: 'عمل متواصل بدون توقف', en: 'Always On' },
];

export const PROCESS_STEPS = [
    { n: '01', ar: 'نحلل ونفهم', en: 'Analyze & Understand', d: 'نبدأ بجلسة اكتشاف عميقة — نفهم عملك، سوقك، ومنافسيك — ثم نبني صورة كاملة عن فرص نموّك.' },
    { n: '02', ar: 'نبني الاستراتيجية', en: 'Build the Strategy', d: 'بناءً على البيانات، نضع خطة Growth Engine متكاملة: المحتوى، الإعلانات، القنوات، والجداول الزمنية.' },
    { n: '03', ar: 'ننتج وننشر', en: 'Create & Launch', d: 'وكلاء الذكاء الصناعي ينتجون المحتوى والتصاميم والحملات، ثم ننشرها على قنواتك في الوقت المثالي.' },
    { n: '04', ar: 'نقيس ونطوّر', en: 'Measure & Scale', d: 'تقارير أداء أسبوعية، تحسين مستمر، وتوسيع ما ينجح — حتى يتحوّل النمو من هدف إلى نظام.' },
];

export interface PricingPlan {
    name: string;
    ar: string;
    price: string;
    unit: string;
    feats: string[];
    highlight: boolean;
    tag: string | null;
}

export const PRICING: PricingPlan[] = [
    {
        name: 'Launch', ar: 'الإطلاق', price: '2,200', unit: 'ريال / شهر',
        highlight: false, tag: null,
        feats: ['تحليل سوقي أوّلي', 'خطة محتوى شهرية', '20 منشور سوشال', '4 تصاميم احترافية', 'تقرير أداء شهري'],
    },
    {
        name: 'Growth', ar: 'النمو', price: '4,800', unit: 'ريال / شهر',
        highlight: true, tag: 'Growth Engine كامل',
        feats: ['كل ما في خطة الإطلاق', 'إدارة إعلانات (Meta + Google)', 'محتوى غير محدود', '12 وكيل ذكاء صناعي كاملين', 'CRM وأتمتة التواصل', 'مدير حساب مخصص', 'تقارير أسبوعية مفصّلة'],
    },
    {
        name: 'Enterprise', ar: 'المؤسسات', price: 'تواصل معنا', unit: '',
        highlight: false, tag: null,
        feats: ['استراتيجية مخصصة بالكامل', 'وكلاء مدرّبون على بياناتك', 'تكامل مع أنظمة CRM الحالية', 'فريق دعم مخصص', 'SLA وضمانات أداء'],
    },
];

export const FAQ_DATA = [
    {
        q: 'ما الفرق بين مجرد استديو والوكالات التسويقية التقليدية؟',
        a: 'الوكالات التقليدية تعتمد على فرق بشرية كبيرة وعمليات بطيئة. في مجرد استديو، نجمع ذكاء البيانات مع إبداع الذكاء الصناعي في نظام Growth Engine متكامل — أسرع، أدق، وبتكلفة أقل بكثير.',
    },
    {
        q: 'كيف يعمل نظام Growth Engine عملياً؟',
        a: 'كل قسم من الأقسام الخمسة يُغذّي التالي: البيانات توجّه الاستراتيجية، الاستراتيجية تحكم الإنتاج، الإنتاج يُطلق الحملات، والحملات تولّد بيانات جديدة — دورة نمو تتحسن ذاتياً مع الوقت.',
    },
    {
        q: 'هل أحتاج فريقاً داخلياً للتنسيق معكم؟',
        a: 'لا. نعمل باستقلالية تامة — نتولى كل شيء من الاستراتيجية حتى النشر. كل ما تحتاجه هو مراجعة التقارير الأسبوعية وإعطاؤنا توجيهك العام.',
    },
    {
        q: 'ما مدة الإعداد قبل إطلاق أول حملة؟',
        a: 'خلال أسبوع واحد: جلسة اكتشاف، تحليل السوق، بناء الاستراتيجية — ثم إطلاق الإنتاج فوراً. لا مماطلة ولا انتظار.',
    },
    {
        q: 'هل تناسب خدماتكم كل القطاعات؟',
        a: 'وكلاؤنا مدرّبون على قطاعات متعددة: تجارة إلكترونية، خدمات مهنية، عقارات، تعليم، صحة، مطاعم، وتقنية. كل خطة تُكيَّف خصيصاً لطبيعة عملك.',
    },
    {
        q: 'ماذا يحدث بعد انتهاء الشهر الأول؟',
        a: 'نُقدّم تقرير أداء شاملاً، نُحلّل ما نجح وما يمكن تحسينه، ثم نضع خطة الشهر التالي بأهداف أعلى. النمو عندنا تراكمي، ليس نقطياً.',
    },
];

export const SOCIAL_PLATFORMS = [
    { name: 'Instagram', icon: '📸', color: '#E1306C', sub: 'صور · ريلز · ستوري' },
    { name: 'TikTok',    icon: '🎵', color: '#010101', sub: 'فيديو · لايف' },
    { name: 'X · تويتر', icon: '✕',  color: '#1DA1F2', sub: 'تغريدات · ثريدز' },
    { name: 'LinkedIn',  icon: 'in', color: '#0A66C2', sub: 'مقالات · بوستات' },
    { name: 'Snapchat',  icon: '👻', color: '#FFFC00', sub: 'قصص · إعلانات' },
    { name: 'YouTube',   icon: '▶',  color: '#FF0000', sub: 'شورتس · فيديو' },
];

export const INTEGRATIONS = [
    { name: 'Google Analytics', cat: 'تحليلات', color: '#E8710A', abbr: 'GA' },
    { name: 'Meta Business',    cat: 'إعلانات', color: '#1877F2', abbr: 'MB' },
    { name: 'TikTok API',       cat: 'محتوى',   color: '#010101', abbr: 'TT' },
    { name: 'Google Ads',       cat: 'إعلانات', color: '#4285F4', abbr: 'GA' },
    { name: 'Shopify',          cat: 'تجارة',   color: '#96BF48', abbr: 'SH' },
    { name: 'HubSpot',          cat: 'CRM',      color: '#FF7A59', abbr: 'HS' },
    { name: 'Semrush',          cat: 'SEO',      color: '#FF642D', abbr: 'SR' },
    { name: 'Snapchat Ads',     cat: 'إعلانات', color: '#FFFC00', abbr: 'SC' },
    { name: 'LinkedIn API',     cat: 'B2B',      color: '#0A66C2', abbr: 'LI' },
    { name: 'WhatsApp API',     cat: 'تواصل',   color: '#25D366', abbr: 'WA' },
    { name: 'Mailchimp',        cat: 'إيميل',   color: '#FFE01B', abbr: 'MC' },
    { name: 'Zapier',           cat: 'أتمتة',   color: '#FF4A00', abbr: 'ZP' },
];

export const REPORT_METRICS = [
    { label: 'تكلفة الاكتساب', val: '↓ 42%', color: '#6FE3C1' },
    { label: 'ROAS الحملات',   val: '3.2x',  color: '#8A7CFF' },
    { label: 'نمو الجمهور',    val: '+18k',  color: '#F472B6' },
    { label: 'معدل التحويل',   val: '↑ 2.8%', color: '#F2C94C' },
];

export const PORTFOLIO_CASES = [
    { client: 'متجر أزياء سعودي', tag: 'استراتيجية · محتوى · إعلانات', metric: '+340%', label: 'نمو المبيعات خلال 90 يوم', bg: 'linear-gradient(135deg,#1A1640,#4A3FC9)' },
    { client: 'تطبيق توصيل',       tag: 'SEO · سوشال · CRM',            metric: '2.4M',  label: 'مشاهدة شهرياً من محتوى عضوي', bg: 'linear-gradient(135deg,#FF8A65,#F2C94C)' },
    { client: 'عيادة تجميل',       tag: 'إعلانات · CRM · ريلز',         metric: '85%',   label: 'تراجع تكلفة الاكتساب (CAC)', bg: 'linear-gradient(135deg,#6FE3C1,#4A9D8F)' },
    { client: 'سلسلة مطاعم',       tag: 'براندنج · مطبوعات · سوشال',   metric: '3.2x',  label: 'ROAS متوسط للحملات الإعلانية', bg: 'linear-gradient(135deg,#0E0B2E,#231B6E)' },
];
